import {isMatch} from "lodash";

import {GanymedePermissions} from "@slices/GanymedePermissions/Permissions";
import {Permissions} from "@slices/Permissions/Permissions";
import {IceObjectConstructor} from "src/utils/ice";


export function findPermission<P extends Permissions.AbstractPermission>(
  permissions: Permissions.AbstractPermission[] | null,
  permissionClass: IceObjectConstructor<P>,
  matches?: Partial<P>,
): P | undefined {
  if (permissions == null)
    return undefined;

  for (const permission of permissions) {
    if (permission instanceof permissionClass) {
      if (matches == null || isMatch(permission, matches as any))
        return permission;
    }
  }

  return undefined;
}

export const knownPermissions: string[] = [];

for (const value of Object.values(GanymedePermissions)) {
  if (value.ice_staticId)
    knownPermissions.push(value.ice_staticId());
}

Object.freeze(knownPermissions);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/services/permissions.ts